import { render, staticRenderFns } from "./Loadings.vue?vue&type=template&id=7d033367&scoped=true&"
import script from "./Loadings.vue?vue&type=script&lang=js&"
export * from "./Loadings.vue?vue&type=script&lang=js&"
import style0 from "./Loadings.vue?vue&type=style&index=0&id=7d033367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d033367",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d033367')) {
      api.createRecord('7d033367', component.options)
    } else {
      api.reload('7d033367', component.options)
    }
    module.hot.accept("./Loadings.vue?vue&type=template&id=7d033367&scoped=true&", function () {
      api.rerender('7d033367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loadings.vue"
export default component.exports